import React, { useEffect } from 'react';
import PageLayout from 'new/elements/pageLayout/PageLayout';
import { ScreenComponent } from 'new/routes/RouterManager';
import * as PATHS from 'js/constants/pathnames';
import { UpdatePassword } from 'new/components/settings/SecurityNPrivacy/components/UpdatePassword';
import { SessionHistory } from 'new/components/settings/SecurityNPrivacy/components/SessionHistory';
import { useDispatch } from 'react-redux';
import { setContextualSupport, unsetContextualSupport } from 'js/actions';
import { SUPPORT_KEY_ACCOUNT } from 'js/constants/supportPageKeys';

interface SecurityNPrivacyProps {}

export const SecurityNPrivacy: ScreenComponent<any> = (props: SecurityNPrivacyProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setContextualSupport(SUPPORT_KEY_ACCOUNT));
    return function cleanup() {
      dispatch(unsetContextualSupport(SUPPORT_KEY_ACCOUNT));
    };
  }, []);

  return (
    <PageLayout
      title="Security & Privacy"
      description="Update your password and review your session history."
    >
      <UpdatePassword />
      <SessionHistory />
    </PageLayout>
  );
};

SecurityNPrivacy.screenConfig = {
  path: `${PATHS.ROUTE_REDESIGN}/settings/security-privacy`,
  screenName: 'SecurityNPrivacy',
  header: {
    title: 'Security & Privacy',
    slugTitle: 'Security & Privacy',
  },
  domain: 'settings',
};
